import Rx from 'rx';
import moment from 'moment';
import {isValidDate} from "../app";
import {notAuthorizedMessage} from './not-authorized.js';

export default function TradesService($wamp, progressBar, UserService) {

  let tradesSubject = new Rx.ReplaySubject(1);

  //todo make meta a subject
  let meta = {}, report;

  // Filters for the Trades board to open with, once: the home page's flow chart sets them.
  let openingFilters = null;

  /**
   * Loads report `r` into the board's subject. `onRefused(message)` hears the backend's message when
   * it won't show this login the board (no trading access).
   */
  function load(r, onRefused) {

    report = r || 'current';

    let rpc = () => {
      progressBar.add('trades');
      return $wamp.call('org.eggs.get_trades', [report]);
    };

    if (isValidDate(report)) {
      rpc = () => {
        progressBar.add('trades');
        return $wamp.call('org.eggs.get_trades_history', [report]);
      };
    }

    return Rx.Observable
        .defer(rpc)
        .repeatWhen(function (attempts) {
          return attempts.concatMap(UserService.subject.take(1)).filter(function (user) {
            return user.roles.indexOf('refresh') > 0;
          }).delay(300000);
        })
        .map(function (res) {
          meta.reportDate = res.args[1];
          return res.args[0] || [];
        })
        .tap(function () {
          meta.lastUpdated = new Date();
          progressBar.remove('trades');
        })
        .subscribe(
            function (trades) {
              tradesSubject.onNext(trades);
            },
            function (err) {
              progressBar.remove('trades');
              const message = notAuthorizedMessage(err);
              if (message && onRefused) {
                onRefused(message);
                return;
              }
              console.error(err);
            });
  }

  return {
    subject: tradesSubject,
    get: function (TradeNo) {
      return tradesSubject
          .flatMap(function (trades) {
            return Rx.Observable.from(trades);
          })
          .filter(function (trade) {
            return trade.TradeNo === TradeNo;
          })
          .debounce(100) //Performance loop
          ;
    },
    load: load,
    meta: function () {
      return meta;
    },
    clear: function () {
      tradesSubject.onNext([]);
    },
    currentReport: function () {
      return report;
    },
    openWith: function (filters) {
      openingFilters = filters;
    },
    takeOpeningFilters: function () {
      const filters = openingFilters;
      openingFilters = null;
      return filters;
    },
    // Tells the backend a member applied, changed or cleared the board's Filters, so it lands in
    // the RPC log. Best effort: nothing is shown and a failure is ignored.
    logFilters: function (selection, resultCount, source) {
      return $wamp.call('org.eggs.filter_applied', ['trades', selection, resultCount, source])
          .catch(function () {});
    }

  };
}
